
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: 'ApplyPersonDialog',
  components: {},
})
export default class ApplyPersonDialog extends Vue {
  @Prop({type: Boolean}) isMaterial!: any;
}
